module.exports = __webpack_public_path__ + "static/media/automa-logo_1.36930651.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/automa-logo_1.png
// module id = 485
// module chunks = 1